import angular from 'angular';
import addFormApp from './app-entry';
import { getHttpApi } from '@cian/http-api/browser';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { initStore } from '../../../shared/reducers';
import { getTelemetry } from '@cian/telemetry/browser';
import { selectIsLoggedIn, selectUserId } from '../../../shared/selectors/user';
import { TelemetryService as initTelemetryService } from './services/telemetry.service';
import { getMicrofrontend } from '@cian/mf-registry/browser';
import { createMicrofrontendAPI } from '../../services/microfrontends/createMicrofrontendAPI';

const DEFAULT_CPL_OFFSET = 155;
const CPL_BLOCK_NAME = '.agent-cpl-description';

angular
  .module('cian.addForm.app', [addFormApp.name])
  .constant('uibButtonConfig', {
    activeClass: 'cui-switcher__part_state_active',
    toggleEvent: 'click',
  })
  .config([
    '$provide',
    function ($provide) {
      const config = getConfig();
      const logger = getLogger();
      const httpApi = getHttpApi();
      const telemetry = getTelemetry();
      const telemetryService = initTelemetryService();
      const microfrontend = getMicrofrontend();
      const microfrontendsApi = createMicrofrontendAPI(microfrontend);

      const store = initStore({ config, logger, httpApi, telemetryService, microfrontend, microfrontendsApi });

      $provide.constant('config', config);
      $provide.constant('logger', logger);
      $provide.constant('httpApi', httpApi);
      $provide.constant('telemetry', telemetry);
      $provide.constant('store', store);
      $provide.constant('microfrontend', microfrontend);
      $provide.constant('microfrontendsApi', microfrontendsApi);
    },
  ])
  .run([
    '$rootScope',
    'homeownerService',
    'authService',
    'activeDraftService',
    'ngStoreToReduxMergeService',
    'store',
    function ($rootScope, homeownerService, authService, activeDraftService, ngStoreToReduxMergeService, store) {
      const { userType, userCanPublishThisOfferAsHomeowner } = homeownerService;
      const isLimitedHomeowner = userType === 'homeowner' && !userCanPublishThisOfferAsHomeowner;

      const state = store.getState();

      let savedDraft;

      try {
        savedDraft = JSON.parse(localStorage.getItem('savedDraft'));
      } catch (e) {
        savedDraft = null;
      }

      if (savedDraft && window.location.search.includes('remoteAd=1')) {
        localStorage.removeItem('savedDraft');
        savedDraft = null;
      }

      if (savedDraft) {
        const isLoggedIn = selectIsLoggedIn(state);
        const userId = selectUserId(state);

        // Восстанавливаем из localStorage только если это
        // не авторизованный агент или черновик создан при смене региона
        const isAgent = isLoggedIn && !userCanPublishThisOfferAsHomeowner;
        const isLocationChanged = !!savedDraft.locationChanged;

        if ((isLocationChanged || !isAgent) && savedDraft.userId === userId) {
          delete savedDraft.locationChanged;
          delete savedDraft.userId;

          window.addFormState.draft = savedDraft;
        }

        localStorage.removeItem('savedDraft');
      }

      // Если есть локальный черновик, но ФП будет скрыто для ограниченного собственника, черновик удалим
      if (!window.addFormState.draft || (isLimitedHomeowner && !window.addFormState.draft.id)) {
        // Если не удалить существующий активный черновик, то при переключении на агента
        // новый черновик не сможет сохраняться, т.к. на сервере уже хранится один.
        // А не удалять нельзя, потому что поля объявления собственника могут отличаться от полей объявления агента
        if (window.addFormState.draft && window.addFormState.draft.objectGuid) {
          activeDraftService.deleteDraft(window.addFormState.draft.objectGuid);
          $rootScope.ad = {
            objectGuid: window.addFormState.draft.objectGuid,
          };
        } else {
          $rootScope.ad = {};
        }
      } else {
        $rootScope.ad = window.addFormState.draft;
      }
      $rootScope.savedAd = window.addFormState.offer || null;
      $rootScope.user = window.addFormState.user || {};
      $rootScope.regions = window.addFormState.regions || {};
      $rootScope.countryCodes = window.addFormState.countryCodes || {};

      authService.isLastStepLogin = !!window.addFormState.anonymousUserCanFillForm;

      ngStoreToReduxMergeService.subscribe();
    },
  ]);

// скролим к блоку "В этом жилом комплексе можно разместить объявление только по договору уступки права требования.",
// что бы прупредить агента почему его форма не валидируется
document.addEventListener('DOMContentLoaded', () => {
  const cplDescriptionElement = document.querySelector(CPL_BLOCK_NAME);

  if (cplDescriptionElement) {
    window.scrollTo(0, cplDescriptionElement.offset().top - DEFAULT_CPL_OFFSET);
  }
});
